import { render } from "./TableStat.vue?vue&type=template&id=5aa033cf"
import script from "./TableStat.vue?vue&type=script&lang=js"
export * from "./TableStat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__